<template >
  <div style="padding:56px 0px;">
    <div></div>
    <div v-if="false">
      <mt-button
        @click="selectTypes(type)"
        size="small"
        :type="type==currentType?'primary':'default'"
        v-for="type in types"
        :key="type"
      >{{type}}</mt-button>
    </div>
    <div>
     <br>
      <div @click="toChart(item.c1)" v-for="item in datalist" :key="item.symbol" class="hbox unline">
           
           <div class="hbox" style="justify-content: flex-start;width: 100%;">
           <div style="width: 40px;height: 40px;border-radius: 20px;display: flex;justify-content: center;align-items: center;color:white;">
            <img  :src="item.icon"> 
            <!--<h2 >{{item.c1.substr(0,1).toUpperCase()}}</h2>-->
            </div>

        <div class="itemclass">
         
          <div>{{item.cname}}</div>
          <div>{{item.name | upper}}</div>
        </div>
      </div>
        <div class="hbox">
            <div style="padding-right:20px;">
              <p style="color:red">{{item.price | toFixed}}</p>
           </div>
        
       
        <div>
          <div
            class="up"
            style="background-color:red"
            v-if="item.upradio>0"
          >{{item.upradio | upradio}}</div>
          <div class="up" style="background-color:#03ad8f;" v-else>{{item.upradio | upradio}}</div>
        </div>
         </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      currentType: "创新板",
      types: [ "主板", "创新板"],
      tabs: ["USDT", "HUSD", "BTC", "ETH", "HT", "TRX"],
      currentTab: "USDT",
      zhuban:[
        {
          symbol:"btcusdt",
          c1:"btc",
          c2:'usdt',
        },
        {
          symbol:"ethusdt",
          c1:"eth",
          c2:'usdt',
        },
        {
           symbol:'xmrusdt',
           c1:'xmr',
           c2:'usdt',
        },
        {
           symbol:'eosusdt',
           c1:'eos',
           c2:'usdt'
        },
        {
           symbol:'bhtusdt',
           c1:'bht',
           c2:'usdt'
        },
        {
          symbol:'hiveusdt',
          c1:'hive',
          c2:'usdt'
        },
        {
          symbol:'thetausdt',
          c1:'theta',
          c2:'usdt'
        }
      ],
     
//      datalist: []
    };
  },
  filters: {
    symbol2txt(symbol) {},
    toFixed(value) {
      return value.toFixed(2);
      
    },
    upradio(item) {
      return (item * 100).toFixed(2) + "%";
    },
    upper(s)
    {
     return s.toUpperCase();
    }
    
  },
  mounted(){
     this.selectTypes("创新版")
  },
  computed:{
     data2(){
         return this.$store.state.currencylist
     },
     datalist(){
       return this.$store.state.chuangxin;
     }
  },
  methods: {
    symbox2dis(symbol, c) {
      let lowcase = symbol.toLowerCase();
      let inx = lowcase.indexOf(c);
      return lowcase.replace(c, "/" + c).toUpperCase();
    },
    toChart(symbol) {
        
        this.$router.push({
             name: "chart",
               params: {
                  symbol: symbol,
                  symbolName: symbol.toUpperCase()
              }
          });


      /*if(this.$store.state.user.balance<100){
           //this.$router.push("/one-trade")
            if(this.$store.state.chongzhi2kefu) {
                  window.toService();
            }
            else {
                this.$router.push("/one-trade")
            }
           
      }
      else {
          this.$router.push({
             name: "chart",
               params: {
                  symbol: symbol,
                  symbolName: symbol.toUpperCase()
              }
          });
      }*/
    },
    selectTypes(value) {
      this.currentType=value;
      if(value=='主板'){
         this.datalist = this.$store.state.zhuban;
      }
      else {
         this.datalist = this.$store.state.chuangxin;
      }
       
    },
    getDataBySymbol(symbol){
        return this.$store.state.tickers.filter((item)=>{
          return item.symbol==symbol
        })[0]
    },
   
  }
};
</script>

<style scoped>
.hbox {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  align-items: center;
}
.itemclass {
  padding-left:10px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  
}
.itemsymbol {
  padding: 10px;
}
.up {
  padding: 10px;
  color: white;
  width:80px;
  text-align: center;
  border-radius: 5px;
}
.unline{
  border-top:#dddddd 1px solid;
}
</style>


// WEBPACK FOOTER //
// src/pages/Market.vue